import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { OverviewSection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-section';
import { DealerMapProvider } from '@phoenix/core/frontend/shared/ui/dealers/context/dealer-map-context';
import { DealerListProvider } from '@phoenix/core/frontend/shared/ui/dealers/context/dealer-list-context';

import { MainDealer } from './main-dealer';

export const MainDealerSection: FC = () => {
  const { t } = useTranslation();
  const { 'main-dealer': flagEnabled } = useFlags();

  return (
    flagEnabled && (
      <OverviewSection
        headline={t('dashboard_mainDealer_headline')}
        subHeadline={t('dashboard_mainDealer_subheadline')}
        dataTestId="my-dealers"
      >
        <DealerMapProvider initialRequest={{ requestType: 'MAIN_DEALER', selectDealer: 'MAIN_DEALER' }}>
          <DealerListProvider>
            <MainDealer />
          </DealerListProvider>
        </DealerMapProvider>
      </OverviewSection>
    )
  );
};
